import styled from "styled-components";

export const SectionHead = styled.h1.attrs((props) => ({
  className: "form-heading",
}))`
  text-align: left !important;
  color: #8d8d8d !important;
`;
